import { TIRE_FRONT_INPUT_NAME, TIRE_REAR_INPUT_NAME } from 'constant'

export default {
  frontTire: {
    name: TIRE_FRONT_INPUT_NAME,
    type: 'text',
    maxValue: 6,
    minValue: 0
  },

  rearTire: {
    name: TIRE_REAR_INPUT_NAME,
    type: 'text',
    maxValue: 6,
    minValue: 0
  }
}
